import { render, staticRenderFns } from "./AnimalTable.vue?vue&type=template&id=45746418&scoped=true&"
import script from "./AnimalTable.vue?vue&type=script&lang=js&"
export * from "./AnimalTable.vue?vue&type=script&lang=js&"
import style0 from "./AnimalTable.vue?vue&type=style&index=0&id=45746418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45746418",
  null
  
)

export default component.exports